/* tslint:disable:max-line-length */
import { Directive, TemplateRef } from '@angular/core';
/**
 * Used for rendering content when there is no data present.
 *
 * To define the no-data template, nest a `<ng-template>` tag with the `kendo<ComponentName>NoDataTemplate` directive inside the component tag.
 *
 * You can use:
 * - The `kendoAutoCompleteNoDataTemplate` directive for the AutoComplete.
 * - The `kendoComboBoxNoDataTemplate` directive for the ComboBox.
 * - The `kendoDropDownListNoDataTemplate` directive for the DropDownList.
 * - The `kendoMultiSelectNoDataTemplate` directive for the MultiSelect.
 *
 *
 * @example
 * ```ts
 * _@Component({
 * selector: 'my-app',
 * template: `
 *  <kendo-combobox [data]="listItems">
 *    <ng-template kendoComboBoxNoDataTemplate>
 *      <h4>No data!</h4>
 *    </ng-template>
 *  </kendo-combobox>
 * `
 * })
 * class AppComponent {
 *   public listItems: Array<string> = [];
 * }
 * ```
 *
 * For more examples, refer to the article on [templates]({% slug templates_ddl %}).
 */
var NoDataTemplateDirective = /** @class */ (function () {
    function NoDataTemplateDirective(templateRef) {
        this.templateRef = templateRef;
    }
    NoDataTemplateDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoDropDownListNoDataTemplate],[kendoComboBoxNoDataTemplate],[kendoAutoCompleteNoDataTemplate],[kendoMultiSelectNoDataTemplate]'
                },] },
    ];
    /** @nocollapse */
    NoDataTemplateDirective.ctorParameters = function () { return [
        { type: TemplateRef, },
    ]; };
    return NoDataTemplateDirective;
}());
export { NoDataTemplateDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-dropdowns/dist/es/templates/no-data-template.directive.js
// module id = ../../../../@progress/kendo-angular-dropdowns/dist/es/templates/no-data-template.directive.js
// module chunks = vendor